import * as layerOps from '../api/Layers/layer-operations';

const parseDataArrayTable = dataArray => {
  const tableTitle = [];
  const tableBody = [];
  const coordinates = [];

  dataArray.forEach(currentObj => {
    const filteredCurrentObj = { ...currentObj };
    delete filteredCurrentObj.tags;
    const objKeys = Object.keys(filteredCurrentObj);
    objKeys.forEach(prop => {
      if (objKeys.includes(prop)) {
        if (!tableTitle.includes(prop)) {
          tableTitle.push(prop);
        }
      }
    });
    const featureArray = [];
    tableTitle.forEach(prop => {
      if (prop in filteredCurrentObj) {
        featureArray.push(filteredCurrentObj[prop]);
      } else {
        featureArray.push('-');
      }
    });
    coordinates.push(filteredCurrentObj.latLng0);
    tableBody.push(featureArray);
  });

  return { tableBody, tableTitle, coordinates };
};

/**
 * Fetches the geojson and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The GeoJSON layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadAnnotationsTable = async layer => {
  let tableTitle = [];
  let tableBody = [];
  let coordinates = [];

  const geojson = layerOps.getAnnotationLayerProperties(layer);
  const arrayTemplates = geojson.geojsonAnnotations.features.map(
    index => index.properties.template
  );
  ({ tableBody, tableTitle, coordinates } = parseDataArrayTable(arrayTemplates));

  return { tableBody, tableTitle, coordinates };
};

export default loadAnnotationsTable;
